import { gql } from '@apollo/client';

// The full section config is fetched/returned everywhere so a save round-trips the
// canonical server state (updateProgressiveAdsSectionConfig is a full-replace upsert).
const PRA_SECTION_CONFIG_FRAGMENT = gql`
  fragment PraSectionConfigData on PraSectionConfig {
    section
    namespace
    enabled
    cooldownSeconds
    rewards {
      isRandomBox
      reward {
        type
        amount
        itemId
      }
    }
    randomBox {
      freePool {
        itemsPerOpening
        contents {
          weight
          reward {
            type
            itemId
          }
          amountMode
          amount
          minAmount
          maxAmount
        }
      }
      purchasePool {
        itemsPerOpening
        contents {
          weight
          reward {
            type
            itemId
          }
          amountMode
          amount
          minAmount
          maxAmount
        }
      }
      priceDiamonds
      purchaseCapPerCycle
    }
    maintenance
    maintenanceSince
    updatedAt
  }
`;

// Namespace is deliberately omitted from the query and both mutations: the server
// defaults to its own namespace (test/beta/prod admin each talk to their backend).
export const GET_PROGRESSIVE_ADS_CONFIGS = gql`
  query getProgressiveAdsConfigs {
    liveOps {
      progressiveAdsConfigs {
        ...PraSectionConfigData
      }
    }
  }
  ${PRA_SECTION_CONFIG_FRAGMENT}
`;

export const UPDATE_PRA_SECTION_CONFIG = gql`
  mutation updateProgressiveAdsSectionConfig($input: UpdatePraSectionConfigInput!) {
    updateProgressiveAdsSectionConfig(input: $input) {
      config {
        ...PraSectionConfigData
      }
      warnings
    }
  }
  ${PRA_SECTION_CONFIG_FRAGMENT}
`;

export const SET_PRA_MAINTENANCE = gql`
  mutation setProgressiveAdsMaintenance($input: SetPraMaintenanceInput!) {
    setProgressiveAdsMaintenance(input: $input) {
      config {
        ...PraSectionConfigData
      }
      warnings
    }
  }
  ${PRA_SECTION_CONFIG_FRAGMENT}
`;
